/**
 * Data sharing treats tenants without a tenant type as Learn tenants.
 */
export const isLearnOrUnsetType = (tenantType?: string | null) =>
  !tenantType || tenantType.toLowerCase() === 'learn';
